import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 0  // 不同小程序对接同一后台
// appid：0-维应SPR开发版 | 2000-维应SPR


// 提交数据获取海报的tkid 396
export function getPosterTkid(data) {
    return request({
        url: '/service/view/ams_seapagetoken_Hand.ashx',
        method: "get",  //接口方法
        params: {
            method: 'ams_seapagetokenadd',
            ...data
        },
    })
}

// 根据tkid获取生存的海报 397
export function getPosterImg(data) {
    return request({
        url: '/service/view/qrcode.aspx',
        method: "get",  //接口方法
        params: {
            tkid: data
        },
        responseType: 'blob',
    })
}

// 获取企业一级标签 154
export function getQyFirstLevelLabel() {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel'
        }
    })
}

// 获取企业二级标签 155
export function getQyTwoLevelLabel(id) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel2',
            parentid: id
        }
    })
}

// 获取企业三级标签 156
export function getQyThreeLevelLabel(id) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel3',
            parentid: id
        }
    })
}

// 获取部门列表 269
export function getDeptList(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_dept',
            ...data
        }
    })
}

// 获取部门下角色 270
export function getDeptRole(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_dept_role',
            ...data
        }
    })
}

// 管理员设置成员的部门或角色 282
export function setUserDepRole(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_deptrole',
            ...data
        }
    })
}

// 获取企业列表 227 
export function getCompanyList(data) {
    return request({
        url: '/service/sumlist.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'LoadPagedams_farming_qy',
            appid,
            ...data
        }
    })
}

// 获取企业信息详情 199
export function getCompanyInfo(data) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user',
            ...data
        }
    })
}

// 修改企业信息 161
export function editCompany(data) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_edit',
            appid,
            ...data
        }
    })
}

// 用户申请加入企业 263
export function applyAddCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_useradd',
            ...data
        }
    })
}

// 用户申请加入企业 264
export function getApplyCompanyList(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user',
            ...data
        }
    })
}

// 取消申请加入企业 281
export function cancelApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_cancel',
            ...data
        }
    })
}

// 企业管理员拒绝 265
export function refuseApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_refuse',
            ...data
        }
    })
}

// 企业管理员同意 266
export function acceptApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_accept',
            ...data
        }
    })
}

// 用户退出企业 267
export function userExitCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_exit',
            ...data
        }
    })
}

// 管理员把用户移除企业 268
export function userRemoveCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_del',
            ...data
        }
    })
}

// 企业微信一键创建企业
export function wx_editQy(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'onece_create',
            appid,
            ...data
        }
    })
}

// 企业微信一键加入企业
export function wx_addQy(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'onece_join',
            appid,
            ...data
        }
    })
}

// 企业的合作商家列表 365
export function getCooperationQy(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_cmuserchecklist',
            ...data
        }
    })
}

// 企业的合作商家详情 366
export function getCooperationQyDetail(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_cmusercheckview',
            ...data
        }
    })
}

// 移除合作商家 367
export function removeCooperationQy(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_cmusercheckdel',
            ...data
        }
    })
}

// 同意成为合作商家 368
export function agreeCooperationQy(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_cmusercheckedit',
            ...data
        }
    })
}

// 拒绝成为合作商家 369
export function refuseCooperationQy(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_cmusercheckedit',
            ...data
        }
    })
}

// 修改是否允许快速发布商品字段 425
export function updateIsquick(data) {
    return request({
        url: '/service/cmusercheck.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'update_isquick',
            ...data
        }
    })
}

// 商品&混批管理-新增 378
export function addShopHPfLogistics(data) {
    return request({
        url: '/service/qy_runrule.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_runruleadd',
            ...data
        }
    })
}

// 商品&混批管理-修改 379
export function editShopHPfLogistics(data) {
    return request({
        url: '/service/qy_runrule.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_runruleedit',
            ...data
        }
    })
}

// 商品&混批管理-列表 380
export function getShopHPfLogistics(data) {
    return request({
        url: '/service/qy_runrule.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_runrulelist',
            ...data
        }
    })
}

// 客户企业主体-添加 399
export function addCustomQy(data) {
    return request({
        url: '/service/view/qy_customer_body_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_bodyadd',
            ...data
        }
    })
}

// 客户企业主体-修改 400
export function editCustomQy(data) {
    return request({
        url: '/service/view/qy_customer_body_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_bodyedit',
            ...data
        }
    })
}

// 客户企业主体-列表 401
export function getCustomQyList(data) {
    return request({
        url: '/service/view/qy_customer_body_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_bodylist',
            ...data
        }
    })
}

// 客户物流信息-列表 414
export function getCustomAddressList(data) {
    return request({
        url: '/service/view/qy_customer_run_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_runlist',
            ...data
        }
    })
}

// 客户物流信息-新增 415
export function addCustomAddress(data) {
    return request({
        url: '/service/view/qy_customer_run_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_runadd',
            ...data
        }
    })
}

// 客户物流信息-修改 416
export function editCustomAddress(data) {
    return request({
        url: '/service/view/qy_customer_run_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_runedit',
            ...data
        }
    })
}

// 客户物流信息-详情 417
export function getCustomAddressDetail(data) {
    return request({
        url: '/service/view/qy_customer_run_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'qy_customer_runview',
            ...data
        }
    })
}

// 企业消费规则-添加 426
export function addConsumptionRule(data) {
    return request({
        url: '/service/view/ams_farming_qy_costrule_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_costruleadd',
            ...data
        }
    })
}

// 企业消费规则-修改 427
export function editConsumptionRule(data) {
    return request({
        url: '/service/view/ams_farming_qy_costrule_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_costruleedit',
            ...data
        }
    })
}

// 企业消费规则-查看 428
export function getConsumptionRule(data) {
    return request({
        url: '/service/view/ams_farming_qy_costrule_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_costruleview',
            ...data
        }
    })
}
